<template>
  <div class="dod-container" v-if="!loading">
    <dod-view-title :title="'Podopieczni'" />
    <dod-search-input
      :withMonthSwitcher="true"
      :with-filters="true"
      :filter-settings="[
        'CUSTOMER_STATUS',
        'DEPARTMENT',
        'PRIORITY_STATUS',
        'SCOPE_OF_CARE',
      ]"
      @search="handleSearch"
      @onFilter="handleFilters"
      @onMonthChange="onMonthChange"
      :date="date"
    />

    <pagination-arrows
      v-if="customers.meta"
      :onPage="customers.meta.per_page"
      :pageNumber="customers.meta.current_page"
      :total="customers.meta.total"
      @nextPage="handleNextPage"
      @previousPage="handlePreviousPage"
    />

    <table
      class="table table-striped"
      v-if="customers && customers.data && customers.data.length > 0"
    >
      <thead>
        <tr>
          <td>Podopieczny</td>
          <td>Status</td>
          <td>Wydział</td>
          <td>Adres</td>
          <td>Numer telefonu</td>
          <td>Dni</td>
          <td>Ilość godz. zaplanowanych</td>
          <td>Ilość godz. wykonanych</td>
          <td></td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="customer in customers.data" :key="customer.id">
          <td>{{ customer.firstName }} {{ customer.lastName }}</td>
          <td>{{ customer.status }}</td>
          <td>{{ customer.department }}</td>
          <td>{{ customer.address }}</td>
          <td>{{ customer.phone }}</td>
          <td>{{ customer.days }}</td>
          <td>{{ customer.numberOfHours || 0 }}</td>
          <td>{{ customer.numberOfMadeHours || 0 }}</td>
          <td>
            <gradient-button
              @handleClick="moveToCustomerDetails(customer.id)"
              :title="'Przejdź'"
              :customStyles="'width: 5vw; font-size: calc(11px + 0.05vw);'"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <dod-empty-list v-else />
  </div>
</template>

<script>
import DodSearchInput from "../../components/dod/DodSearchInput.vue";
import DodViewTitle from "../../components/dod/DodViewTitle.vue";
import moment from "moment";
import GradientButton from "../../components/dod/GradientButton.vue";
import DodEmptyList from "../../components/dod/DodEmptyList.vue";
import PaginationArrows from "../../components/PaginationArrows.vue";

const defaultLimit = 20;

export default {
  components: {
    DodViewTitle,
    DodSearchInput,
    GradientButton,
    DodEmptyList,
    PaginationArrows,
  },
  name: "DODCustomersList",

  data() {
    return {
      loading: true,
      month: "",
      year: "",
      filters: {},
      search: "",
      date: "",
      limit: defaultLimit,
      page: 1,
    };
  },

  async mounted() {
    const now = moment();
    this.date = now.toDate();
    this.month = now.get("month") + 1;
    this.year = now.get("year");
    await this.fetchCustomers();
    this.loading = false;
  },

  methods: {
    async handleNextPage() {
      this.page++;
      await this.fetchCustomers();
    },
    async handlePreviousPage() {
      this.page--;
      await this.fetchCustomers();
    },
    async fetchCustomers() {
      await this.$store.dispatch("getDodCustomersInMonth", {
        search: this.search,
        filters: this.filters,
        month: this.month,
        year: this.year,
        limit: this.limit,
        page: this.page,
      });
    },

    async onMonthChange(date) {
      const dateToSet = moment(date);
      this.date = dateToSet.toDate();
      this.month = dateToSet.get("month") + 1;
      this.year = dateToSet.get("year");
      this.page = 1;
      this.limit = defaultLimit;
      await this.fetchCustomers();
    },
    async handleSearch(searchValue) {
      this.search = searchValue;
      this.page = 1;
      this.limit = defaultLimit;
      await this.fetchCustomers();
    },

    async handleFilters(filters) {
      this.filters = {};
      if (filters) {
        filters.forEach((filter) => (this.filters[filter.key] = filter.value));
      }
      this.page = 1;
      this.limit = defaultLimit;
      await this.fetchCustomers();
    },

    moveToCustomerDetails(customerId) {
      this.$router.push({
        name: "DodCustomerDetails",
        params: { id: customerId },
      });
    },
  },
  computed: {
    customers() {
      return this.$store.getters.getDodCustomersInMonth;
    },
  },
};
</script>

<style scoped>
table {
  table-layout: fixed;
  font-size: calc(11px + 0.05vw);
}
</style>